export default function setUniversalDetailsHistory(from, obj) {
    const newHistory = { [from]: [{ ...obj }] };
    console.log('hereeeee', from);
    sessionStorage.setItem("udHistory", JSON.stringify(newHistory));
};


// WEBPACK FOOTER //
// ./src/utils/udHistory.js